import React, { useState } from 'react';
import arrowup from "../assets/images/arrowupcircle.png";
import data from './Data';

export default function FAQ() {
  const [selection, setSelection] = useState([]);

  // Function to toggle selection
  const handleSelection = (currentId) => {
    setSelection((prevSelection) =>
      prevSelection.includes(currentId)
        ? prevSelection.filter((id) => id !== currentId) 
        : [...prevSelection, currentId] 
    );
  };

  return (
    <div className='md:px-[20%] px-[10%] pb-[6%]'>
      <div className='text-center border-b-[1px] pb-10 border-[#E4E4E4]'>
        <h3 className='md:pt-10 pt-5 text-[1.2rem] md:text-[1.7rem] text-[#002455] font-[800] leading-[1.3]'>
          FA<span className='text-[var(--second-primary-color)]'>Q</span>
        </h3>
        <p className='text-[1rem] font-[400] text-[#000000] leading-[2]'>
          Frequently asked questions
        </p>
      </div>

      {/* about us */}
      <div className='text-[#000000] font-[500] text-[1rem]'>

        {/* FAQ */}
        <div>
          {data && data.length > 0 ? (
            data.map((dataItem) => (
              <div
                key={dataItem.id}
                className="border-b-[1px] border-[#E4E4E4] my-6 pb-2 cursor-pointer"
              >
                <div
                  className="flex justify-between"
                  onClick={() => handleSelection(dataItem.id)}
                >
                  <h3 className="faq-question">{dataItem.title}</h3>
                  <i>
                    <img
                      src={arrowup}
                      alt="indicator"
                      className={`w-[12px] pt-2 transform transition-transform duration-300 ${
                        selection.includes(dataItem.id) ? 'rotate-180' : ''
                      }`}
                    />
                  </i>
                </div>

                {/* Show the answer only if the item is in the selection array */}
                {selection.includes(dataItem.id) && (
                  <div
                    className="faq-answer text-[.9rem] text-[#000000] font-[200] py-2 
                    transition-all duration-500 ease-in-out max-h-[500px] overflow-hidden transform opacity-100"
                  >
                    {dataItem.message}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div>No data found</div>
          )}
        </div>
      </div>
    </div>
  );
}
